/* tslint:disable:jsx-no-lambda */
import jss from "jss";
import { action, computed, observable } from "mobx";
import { observer } from "mobx-react";
import * as QRCode from "qrcode.react";
import * as React from "react";

import {
    CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, WithStyles
} from "@material-ui/core";
import { jssPreset, StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import { API, Button, Text } from "../components";

type ClassNames = "container" | "tabs" | "tab" | "tabContainer" | "qrCode"| "link" | "field" |
"button" | "emoji";

declare function testflight_error(email?: string): void;

const isTestFlightEnabled = false;
const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: 375,
        maxWidth: 450
    },
    tabs: {
        width: "100%",
        display: "flex",
        borderRadius: 5,
        boxShadow:
        "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
    },
    tab: {
        flex: 1,
        marginTop: "0 !important",
        marginBottom: "0 !important",
        borderRadius: "0 !important",
        borderTopWidth: "0 !important",
        borderLeftWidth: "0 !important",
        borderRightWidth: "0 !important"
    },
    tabContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: theme.spacing.unit * 2
    },
    qrCode: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2
    },
    link: {
        color: theme.typography.body1.color
    },
    field: {
        width: "62%"
    },
    button: {
        width: "62%"
    },
    emoji: {
        color: "black"
    }
});

interface TryWithExpoProps {
    name: string,
    expo: string,
    color: string,
    testFlight: string,
    apk: string | null
}

interface TryWithExpoState {
    tab: number
}

@observer
class TryWithExpo extends React.Component<WithStyles<ClassNames> & TryWithExpoProps, TryWithExpoState> {

    public state = {
        tab: 1
    };

    public underlineClass: string;

    @observable public firstName: string = "";
    @observable public lastName: string = "";
    @observable public email: string;
    @observable public _loading: boolean = false;
    @observable public _done: boolean = false;
    @observable public _error: boolean = false;

    @computed get loading() { return this._loading; }
    set loading(loading: boolean) { this._loading = loading; }

    @computed get done() { return this._done; }
    set done(done: boolean) { this._done = done; }

    @computed get error() { return this._error; }
    set error(error: boolean) { this._error = error; }

    public componentWillMount() {
        const {color} = this.props;
        // const theme = this.props.theme as Theme;
        jss.setup(jssPreset());
        const style = {
            underline: {
                "&:after": {
                    borderBottomColor: color
                },
                "&:hover:before": {
                    borderWidth: "1px !important",
                    borderColor: `rgba(0, 0, 0, 0.42) !important`
                }

            }
        };
        // tslint:disable-next-line
        const stylesheet = jss.createStyleSheet(style as any).attach();
        this.underlineClass = stylesheet.classes.underline;
    }

    public handleChange = (tab: number) => {
      this.setState({ tab });
    }

    public handleChangeIndex = (tab: number) => {
      this.setState({ tab });
    }

    @action
    public setFirstName = (e: React.ChangeEvent<HTMLInputElement>) => this.firstName = e.target.value

    @action
    public setLastName = (e: React.ChangeEvent<HTMLInputElement>) => this.lastName = e.target.value

    @action
    public setEmail = (e: React.ChangeEvent<HTMLInputElement>) => this.email = e.target.value

    @action
    public handleClose = () => this.done = false

    @action
    public handleErrorClose = () => this.error = false

    @action
    public resetForm() {
        this.firstName = "";
        this.lastName = "";
        this.email = "";
    }

    public testFlight = async () => {
        const {firstName, lastName, email} = this;
        const project =  this.props.expo.substring(this.props.expo.lastIndexOf("/") + 1);
        this.loading = true;
        try {
            await API.testFlight({ firstName, lastName, email, project });
            this.loading = false;
            this.done = true;
            this.resetForm();
        } catch (e) {
            this.loading = false;
            this.error = true;
            testflight_error(email);
        }
    }

    public render() {
        const {classes, expo, name, color, testFlight, apk} = this.props;
        const {tab} = this.state;
        const theme = this.props.theme as Theme;
        return (
            <div className={classes.container}>
                <div className={classes.tabs}>
                    <Button
                        className={classes.tab}
                        onClick={() => this.handleChange(0)}
                        style={{ borderBottomWidth: tab === 0 ? 2 : 0, borderColor: color }}
                    >
                        <span style={{ color: tab === 0 ? color : "black" }}>iPhone / iPad</span>
                    </Button>
                    <Button
                        className={classes.tab}
                        onClick={() => this.handleChange(1)}
                        style={{ borderBottomWidth: tab === 1 ? 2 : 0, borderColor: color }}
                    >
                        <span style={{ color: tab === 1 ? color : "black" }}>Android</span>
                    </Button>
                </div>
                { tab === 0 && !isTestFlightEnabled && (
                    <div className={classes.tabContainer}>
                        <Text align="center">
                            To get access to the TestFlight version, <a href={testFlight} target="_blank" className={classes.link}>open this link on iOS</a>.
                        </Text>
                        <Button
                            className={classes.button}
                            href={testFlight}
                            target="_blank"
                            {...{ color }}
                        >
                            Open TestFlight invitation
                        </Button>
                    </div>
                )}
                {tab === 0 && isTestFlightEnabled && (
                    <form className={classes.tabContainer} onSubmit={e => { this.testFlight(); e.preventDefault(); }}>
                        <Text align="center">
                            Add your email below to get an invitation via TestFlight.
                            Or <a href={testFlight} target="_blank" className={classes.link}>open this link on iOS</a>.
                        </Text>
                        <TextField
                            className={classes.field}
                            InputProps={{
                                classes: { underline: this.underlineClass }}
                            }
                            placeholder="First Name"
                            margin="normal"
                            value={this.firstName}
                            onChange={this.setFirstName}
                        />
                        <TextField
                            className={classes.field}
                            InputProps={{
                                classes: { underline: this.underlineClass }}
                            }
                            placeholder="Last Name"
                            margin="normal"
                            value={this.lastName}
                            onChange={this.setLastName}
                        />
                        <TextField
                            className={classes.field}
                            InputProps={{
                                classes: { underline: this.underlineClass }
                            }}
                            placeholder="Email"
                            margin="normal"
                            inputProps={{ type: "email" }}
                            required={true}
                            value={this.email}
                            onChange={this.setEmail}
                        />
                        <Button
                            className={classes.button}
                            disabled={this.loading}
                            type="submit"
                            {...{ color }}
                        >
                            {
                                !this.loading
                                    ?
                                        "Get Access"
                                    :
                                        <CircularProgress
                                            size={theme.typography.body1.lineHeight}
                                            style={{ color: "white" }}
                                        />
                            }
                        </Button>
                    </form>
                )}
                {tab === 1 && (
                    <div className={classes.tabContainer}>
                        <Text align="center">
                            Download the Expo app and scan this QR code to get started.
                            {
                              apk !== null && (
                                <span>
                                  {" "} Or <a href={apk} className={classes.link}>download the apk file</a>.
                                </span>
                              )
                            }
                        </Text>
                        <div className={classes.qrCode}>
                            <QRCode
                                value={expo}
                                fgColor="black"
                            />
                        </div>
                        <Button
                            className={classes.button}
                            href="https://play.google.com/store/apps/details?id=host.exp.exponent"
                            target="_blank"
                            {...{ color }}
                        >
                            Get Expo on Android
                        </Button>
                    </div>
                )}
                <Dialog
                    open={this.done}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                >
                    <DialogTitle id="alert-dialog-title" disableTypography={true}>
                        <Text variant="title3">Invitation sent</Text>
                    </DialogTitle>
                    <DialogContent>
                        <Text>
                            We successfully added you as a tester for {name}.
                            Check your email inbox for an invite.
                        </Text>
                        <Text>
We hope you enjoy the demo. <span className={classes.emoji}>🤗</span>.
Please <a href="mailto:wcandillon@gmail.com" className={classes.link}>let us know</a> if you have any questions.
                        </Text>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} autoFocus={true} {...{color}}>
                          OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.error}
                    onClose={this.handleErrorClose}
                    aria-labelledby="alert-dialog-title"
                >
                    <DialogTitle id="alert-dialog-title" disableTypography={true}>
                        <Text variant="title3">An error happened</Text>
                    </DialogTitle>
                    <DialogContent>
                        <Text>
This is embarassing <span className={classes.emoji}>😅</span>.
Try to open <a href={testFlight} target="_blank">this link</a> on iOS.
Or <a href="mailto:wcandillon@gmail.com" className={classes.link}>sent us an email</a> and
we will add you manually to Apple TestFlight.
                        </Text>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleErrorClose} autoFocus={true} primary={true}>
                          OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })<TryWithExpoProps>(TryWithExpo);



// WEBPACK FOOTER //
// ./src/components/TryWithExpo.tsx